"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AADTType = exports.HeavyVehicleFlowType = exports.SpeedDifferentialType = exports.SpeedAverageType = exports.ProportionOfCargoBikesAndMopedsType = exports.BicycleAndLVFlowType = exports.PedestrianFlowType = exports.NumberOfLanesType = exports.IntersectionApproachType = exports.CurvatureType = exports.GradeType = exports.FlowDirectionType = exports.FacilityWidth = exports.PresenceType = exports.AdequateType = exports.FacilityType = exports.AreaType = void 0;
var AreaType;
(function (AreaType) {
    AreaType["InnerUrban"] = "InnerUrban";
    AreaType["OtherUrban"] = "OtherUrban";
    AreaType["Rural"] = "Rural";
    AreaType["Industrial"] = "Industrial";
})(AreaType || (exports.AreaType = AreaType = {}));
var FacilityType;
(function (FacilityType) {
    FacilityType["Sidewalk"] = "Sidewalk";
    FacilityType["MultiUsePath"] = "MultiUsePath";
    FacilityType["OffRoadBicyclePath"] = "OffRoadBicyclePath";
    FacilityType["OnRoadBicycleLane"] = "OnRoadBicycleLane";
    FacilityType["RoadShoulder"] = "RoadShoulder";
    FacilityType["MixedTrafficRoadLane"] = "MixedTrafficRoadLane";
})(FacilityType || (exports.FacilityType = FacilityType = {}));
var AdequateType;
(function (AdequateType) {
    AdequateType["Adequate"] = "Adequate";
    AdequateType["Inadequate"] = "Inadequate";
})(AdequateType || (exports.AdequateType = AdequateType = {}));
var PresenceType;
(function (PresenceType) {
    PresenceType["Present"] = "Present";
    PresenceType["NotPresent"] = "NotPresent";
})(PresenceType || (exports.PresenceType = PresenceType = {}));
var FacilityWidth;
(function (FacilityWidth) {
    FacilityWidth["VeryNarrow"] = "VeryNarrow";
    FacilityWidth["Narrow"] = "Narrow";
    FacilityWidth["Wide"] = "Wide";
})(FacilityWidth || (exports.FacilityWidth = FacilityWidth = {}));
var FlowDirectionType;
(function (FlowDirectionType) {
    FlowDirectionType["OneWay"] = "OneWay";
    FlowDirectionType["TwoWay"] = "TwoWay";
})(FlowDirectionType || (exports.FlowDirectionType = FlowDirectionType = {}));
var GradeType;
(function (GradeType) {
    GradeType["LessThan5degrees"] = "LessThan5degrees";
    GradeType["MoreThan5degrees"] = "MoreThan5degrees";
})(GradeType || (exports.GradeType = GradeType = {}));
var CurvatureType;
(function (CurvatureType) {
    CurvatureType["SharpTurn"] = "SharpTurn";
    CurvatureType["NoSharpTurn"] = "NoSharpTurn";
})(CurvatureType || (exports.CurvatureType = CurvatureType = {}));
var IntersectionApproachType;
(function (IntersectionApproachType) {
    IntersectionApproachType["Shared"] = "Shared";
    IntersectionApproachType["SeparateOrNA"] = "SeparateOrNA";
})(IntersectionApproachType || (exports.IntersectionApproachType = IntersectionApproachType = {}));
var NumberOfLanesType;
(function (NumberOfLanesType) {
    NumberOfLanesType["OnePerDirection"] = "OnePerDirection";
    NumberOfLanesType["MoreThanOnePerDirection"] = "MoreThanOnePerDirection";
})(NumberOfLanesType || (exports.NumberOfLanesType = NumberOfLanesType = {}));
var PedestrianFlowType;
(function (PedestrianFlowType) {
    PedestrianFlowType["None"] = "None";
    PedestrianFlowType["Low"] = "Low";
    PedestrianFlowType["MediumToHigh"] = "MediumToHigh";
})(PedestrianFlowType || (exports.PedestrianFlowType = PedestrianFlowType = {}));
var BicycleAndLVFlowType;
(function (BicycleAndLVFlowType) {
    BicycleAndLVFlowType["Low"] = "Low";
    BicycleAndLVFlowType["MediumToHigh"] = "MediumToHigh";
})(BicycleAndLVFlowType || (exports.BicycleAndLVFlowType = BicycleAndLVFlowType = {}));
var ProportionOfCargoBikesAndMopedsType;
(function (ProportionOfCargoBikesAndMopedsType) {
    ProportionOfCargoBikesAndMopedsType["LowToModerate"] = "LowToModerate";
    ProportionOfCargoBikesAndMopedsType["ModerateToHigh"] = "ModerateToHigh";
})(ProportionOfCargoBikesAndMopedsType || (exports.ProportionOfCargoBikesAndMopedsType = ProportionOfCargoBikesAndMopedsType = {}));
var SpeedAverageType;
(function (SpeedAverageType) {
    SpeedAverageType["LessThan20kmh"] = "LessThan20kmh";
    SpeedAverageType["MoreThan20kmh"] = "MoreThan20kmh";
})(SpeedAverageType || (exports.SpeedAverageType = SpeedAverageType = {}));
var SpeedDifferentialType;
(function (SpeedDifferentialType) {
    SpeedDifferentialType["LessThan10kmh"] = "LessThan10kmh";
    SpeedDifferentialType["MoreThan10kmh"] = "MoreThan10kmh";
})(SpeedDifferentialType || (exports.SpeedDifferentialType = SpeedDifferentialType = {}));
var HeavyVehicleFlowType;
(function (HeavyVehicleFlowType) {
    HeavyVehicleFlowType["LowOrRestrictedAccess"] = "LowOrRestrictedAccess";
    HeavyVehicleFlowType["MediumToHigh"] = "MediumToHigh";
})(HeavyVehicleFlowType || (exports.HeavyVehicleFlowType = HeavyVehicleFlowType = {}));
var AADTType;
(function (AADTType) {
    AADTType["AADT0"] = "AADT0";
    AADTType["AADT100"] = "AADT100";
    AADTType["AADT500"] = "AADT500";
    AADTType["AADT1500"] = "AADT1500";
    AADTType["AADT2500"] = "AADT2500";
    AADTType["AADT5000"] = "AADT5000";
    AADTType["AADT7500"] = "AADT7500";
    AADTType["AADT10000"] = "AADT10000";
    AADTType["AADT12500"] = "AADT12500";
    AADTType["AADT15000"] = "AADT15000";
    AADTType["AADT17500"] = "AADT17500";
    AADTType["AADT20000"] = "AADT20000";
    AADTType["AADT22500"] = "AADT22500";
    AADTType["AADT25000"] = "AADT25000";
    AADTType["AADT30000"] = "AADT30000";
    AADTType["AADT35000"] = "AADT35000";
    AADTType["AADT40000"] = "AADT40000";
})(AADTType || (exports.AADTType = AADTType = {}));
